import Vue from 'vue'
import App from './App'
import router from './router'
import './filters'
import './http'
import store from './store'
import 'material-design-lite'
import { focus } from 'vue-focus'

Vue.config.productionTip = false

Vue.directive('focus', focus)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App),
  store
})



// WEBPACK FOOTER //
// ./src/main.js